import { Grid, Typography, FormControl, Select, Box, Chip, MenuItem } from '@mui/material';
import { Container } from '@mui/system';
import globals from '../globals';
import React from 'react';
import RedButton from '../components/redButton';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { addDays, areAllArraysEmpty } from '../utils';
import LoadingPage from "../error_page/loadingPage";
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import ErrorPage from "../error_page/errorPage";
const CALENDAR_HEIGHT = 48;
const CALENDAR_PADDIONG_TOP = 8;


const hours = [
    "9:00 - 10:00",
    "10:00 - 11:00",
    "11:00 - 12:00",
    "12:00 - 13:00",
    "13:00 - 14:00",
    "14:00 - 15:00",
    "15:00 - 16:00",
    "16:00 - 17:00",
    "17:00 - 18:00",
    "18:00 - 19:00",
    "19:00 - 20:00",
    "20:00 - 21:00",
];

const CalendarProps = {
    PaperProps: {
        style: {
            maxHeight: CALENDAR_HEIGHT * 4.5 + CALENDAR_PADDIONG_TOP,
            width: 250,
        },
    },
};

const todayDate = new Date();
const startingDay = addDays(todayDate, 3);
let days = [
    "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота", "Неделя"
]
days = days.slice(startingDay.getDay() - 1, 7).concat(days.slice(0, startingDay.getDay() - 1));


const DateTimePage = () => {
    const { id } = useParams();
    const { token } = useAuth();
    const navigate = useNavigate();
    const [calendar, setCalendar] = React.useState({
        'Понеделник': [],
        'Вторник': [],
        'Сряда': [],
        'Четвъртък': [],
        'Петък': [],
        'Събота': [],
        'Неделя': [],
    });
    const [loading, setLoading] = React.useState(true);
    const [showMessage, setShowMessage] = React.useState(false);
    const [showError, setShowError] = React.useState(false);

    const [instructorTimeSlots, setInstructorTimeSlots] = React.useState({});

    useEffect(() => {
        fetch(`${globals.apiUrl}/courses/timeslots/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.detail) {
                    setShowError(true);
                }
                //console.log(data);
                setInstructorTimeSlots({
                    'Понеделник': data.monday,
                    'Вторник': data.tuesday,
                    'Сряда': data.wednesday,
                    'Четвъртък': data.thursday,
                    'Петък': data.friday,
                    'Събота': data.saturday,
                    'Неделя': data.sunday,
                });
                setLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const timeSlots = {
            type: 'normal',
            monday: calendar['Понеделник'],
            tuesday: calendar['Вторник'],
            wednesday: calendar['Сряда'],
            thursday: calendar['Четвъртък'],
            friday: calendar['Петък'],
            saturday: calendar['Събота'],
            sunday: calendar['Неделя'],
        }
        if (areAllArraysEmpty(calendar)) {
            //console.log("All arrays are empty");
            return;
        }
        fetch(`${globals.apiUrl}/courses/timeslots/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(timeSlots),
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setShowMessage(true);
                navigate('/cart');
            })
            .catch(error => {
                console.error('Error:', error);
                // setShowError(true);
            });
    }


    const handleCalendarChange = (day) => (event) => {
        const { value } = event.target;
        //console.log("calendar", calendar);
        setCalendar((prev) => ({
            ...prev,
            [day]: typeof value === "string" ? value.split(",") : value,
        }));
    };

    return (
        <Container>
            {showError ? <ErrorPage /> : loading ? <LoadingPage /> : (
                <Grid container>
                    <Grid item xs={12} sm={12}>
                        <Typography sx={{ color: globals.colors.lightRed, fontSize: 22, fontWeight: 'bold' }}>Избери поне два удобни за теб часа</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 3 }}>
                        {days.map((day, i) => {
                            return { day: day, "date": addDays(startingDay, i) }
                        }).filter(({ day }) => instructorTimeSlots[day].length > 0).map(({ day, date }, i) => (
                            <Grid key={day} sx={{ mb: 3 }}>
                                <Typography sx={{ color: globals.colors.darkBlue }}><strong>{day}</strong> {date.toLocaleDateString("bg-BG", { day: '2-digit', month: '2-digit', year: 'numeric' })}</Typography>
                                <Grid container sx={{ mt: 1 }}>
                                    <FormControl sx={{ width: 400 }}>
                                        <Select
                                            multiple
                                            value={calendar[day] || []}
                                            onChange={handleCalendarChange(day)}
                                            renderValue={(selected) => (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                    {selected.map((value) => (
                                                        <Chip key={value} label={value} />
                                                    ))}
                                                </Box>
                                            )}
                                            MenuProps={CalendarProps}
                                            sx={{
                                                backgroundColor: globals.colors.backgroundColor,
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: globals.colors.darkRed,
                                                },
                                            }}
                                        >
                                            {instructorTimeSlots[day].map((hour) => (
                                                <MenuItem key={hour} value={hour}>
                                                    {hour}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid item>
                        <RedButton text='Продължи към плащане' onClick={handleSubmit} />
                        {
                            showMessage &&
                            <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 13, mt: 2 }}>Очаквай потвърждение по имейл за урока до 48 часа.</Typography>
                        }
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default DateTimePage